import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import ServiceWorkerSetup from "./components/ServiceWorkerSetup";
import { Elements } from "@stripe/react-stripe-js";
import { StripeProvider } from "./context/AuthStripe";
import { loadStripe } from "@stripe/stripe-js";
import { requestInterceptor, responseInterceptor } from "./ajax/interceptors";
import { setToken } from "./utils/helpers";
import Router from "./config/Router";
import AutoScroll from "./components/AutoScroll";
import AddFunds from "./Pages/General/Wallet/Add";

const isBusinessUser = () => {
  const accountType = localStorage.getItem("accountType");
  return accountType === "business";
};

function App() {
  const [initLoad, setInitLoad] = useState(false);
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLIC_KEY || process.env.STRIPE_PUBLIC_KEY || ""
  );

  /* 
 {
      target: '.joyride-first-intro',
      content: 'Welcome to the brook!',
      placement:'bottom',
      disableBeacon: true
    },
  */

  useEffect(() => {
    // Set token in axios headers on app initialization
    // This ensures authenticated users stay logged in when clicking email links
    setToken();
  }, []);

  if (!initLoad) {
    requestInterceptor();
    responseInterceptor();
    setInitLoad(true);
  }

  if (process.env.REACT_APP_STAGE === "PROD") {
    console.log = function no_console() {};
  }

  return (
    <>
      <div
        style={{
          background: "#BEBEFF",
          position: "fixed",
          bottom: 0,
          right: 0,
          left: "0",
          zIndex: "9999999999999999999999999999999999999999999999999999999",
        }}
      >
        <h1
          style={{
            textAlign: "center",
            color: "#003DB5",
            padding: "6px",
            fontSize: "7px",
            margin: "0",
          }}
        >
          We are currently in a Beta release. Any point earned on the league
          table cannot be converted into real cash until payment services start.
          Contact support via tech-support@workbrook.com for technical issues.
        </h1>
      </div>

      <BrowserRouter>
        {/* <ServiceWorkerSetup /> */}
        <AutoScroll>
          <Router business={isBusinessUser()} />
        </AutoScroll>
      </BrowserRouter>
    </>
  );
}

export default App;
